import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCzCg74OCxfKvl_5TeD89Ya8GxkpGcKE6w",
    authDomain: "bible-plan-generator.firebaseapp.com",
    projectId: "bible-plan-generator",
    storageBucket: "bible-plan-generator.firebasestorage.app",
    messagingSenderId: "855226675380",
    appId: "1:855226675380:web:f492d1a0f32348d6dda7e1",
    measurementId: "G-Y252MQMN5M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

const auth = getAuth(app);

export { app, analytics, db, auth };
